export default __webpack_public_path__ + "static/media/2.eb3d7518.gif";